module.exports = __webpack_public_path__ + "static/media/18C_Diesel.d5a6bace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/18C_Diesel.jpg
// module id = 1483
// module chunks = 0